module.exports = __webpack_public_path__ + "static/img/role.8eab419.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/yjyx/role.png
// module id = ez4y
// module chunks = 7